import { get } from '../utils';

export default function register(root: any, data: any, callBack?) {
    get(root, data).then((rd) => {
        callBack && callBack(rd, rd.errCode, rd.errDesc);
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/register.ts